import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "../SignupPages/SignupCommon.css";

const IntakeFormPage6: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const completeIntakeStep3 = localStorage.getItem("complete-intake-step3");
    if (completeIntakeStep3) {
      navigate("/complete-intake/step-4", { replace: true });
    } else {
      navigate("/complete-intake/step-3", { replace: true });
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "past_illness",
        JSON.stringify({
          key: "past_illness",
          value: selectedOption,
          id: 18026058,
        })
      );
    }
    if (selectedOption === "None of the Following") {
      navigate("/complete-intake/step-5");
    } else {
      navigate("/complete-intake/disqualified");
    }
    localStorage.setItem("complete-intake-step4", "true");
  };

  useEffect(() => {
    const savedPastIllness = localStorage.getItem("past_illness");

    if (savedPastIllness) {
      const parsedPastIllness = JSON.parse(savedPastIllness);
      setSelectedOption(parsedPastIllness.value);
    }
  }, []);

  const options = [
    "None of the Following",
    "End-stage kidney disease",
    "End-stage liver disease",
    "Current suicidal thoughts and/or prior suicidal attempt",
    "Cancer",
    "History of Organ Transplant on anti-rejection medication",
    "Severe gastrointestinal condition",
    "Current diagnosis of or treatment for alcohol, opioid, or substance use disorder/dependence",
    "Uncontrolled diabetes",
  ];

  const step = 4;

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={40} step={step} />
        <div className="signup-content">
          <p className="signup-intro">
            Have you experienced any significant medical conditions, either
            currently or in the past, that could impact your health and wellness
            journey?
          </p>
          <div className="options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage6;
